module.exports = __webpack_public_path__ + "static/media/options.633cd874.svg";